import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const palmaCeiaConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Palma Ceia Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in Palma Ceia, FL. Sam\'s Tree Service handles dangerous trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_palma_ceia',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Palma Ceia',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Palma Ceia Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we understand the expectations that 
     come with working in <strong>Palma Ceia</strong>. This prestigious South Tampa 
     neighborhood is defined by its stunning homes, manicured properties, and 
     mature tree canopy. When those trees develop hazards overhanging limbs, 
     storm damage, or structural issues they need expert attention that respects 
     the quality and character of the neighborhood. That's what we deliver.`,
     
    `We specialize in <strong>high care tree removal and trimming on premier 
     residential properties</strong> precision canopy work near luxury homes 
     and pools, large limb removals requiring careful rigging, storm damaged 
     tree response, and full removals executed cleanly on tight, beautifully 
     landscaped lots. We treat your property with the same care you do.`,

    `<strong>Sam's Tree Service</strong> provides expert, trusted tree care 
     throughout <strong>Palma Ceia</strong> and the surrounding 
     <strong>South Tampa</strong> neighborhoods maintaining the beauty 
     and safety of your property all year long.`,
  ],
  ctaLabel: 'Get a Free Estimate!',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Palma Ceia, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_PalmaCeia = () => <LocationPage config={palmaCeiaConfig} />;
export default Services_PalmaCeia;
